import { render, staticRenderFns } from "./PainelSubItens.vue?vue&type=template&id=b7538ae8"
import script from "./PainelSubItens.vue?vue&type=script&lang=js"
export * from "./PainelSubItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports